var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    id: "dollar-coin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,3h-4C6.832,3,1,8.832,1,16s5.832,13,13,13h4c7.168,0,13-5.832,13-13S25.168,3,18,3z M3,16C3,9.935,7.935,5,14,5s11,4.935,11,11s-4.935,11-11,11S3,22.065,3,16z M21.973,26.246C25.026,23.865,27,20.163,27,16s-1.974-7.865-5.027-10.246C26.078,7.352,29,11.336,29,16S26.078,24.648,21.973,26.246z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15,24v-1.142c1.721-0.447,3-2,3-3.858c0-2.206-1.794-4-4-4c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2c0,0.552,0.447,1,1,1s1-0.448,1-1c0-1.858-1.279-3.411-3-3.858V8c0-0.552-0.447-1-1-1s-1,0.448-1,1v1.142c-1.721,0.447-3,2-3,3.858c0,2.206,1.794,4,4,4c1.103,0,2,0.897,2,2s-0.897,2-2,2s-2-0.897-2-2c0-0.552-0.447-1-1-1s-1,0.448-1,1c0,1.858,1.279,3.411,3,3.858V24c0,0.552,0.447,1,1,1S15,24.552,15,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.a524a525bd10a1afc4208c1f8507ab6f.svg";
export { ForwardRef as ReactComponent };